import PropTypes from "prop-types";
import { useRouteMatch } from "react-router-dom";

import EditRecurringGiftModal from "./EditRecurringGiftModal";

EditRecurringGiftModalURLWatcher.propTypes = {
  onModalClose: PropTypes.func,
};

export default function EditRecurringGiftModalURLWatcher({
  onModalClose = () => {},
}) {
  const showEditRecurringModal = useRouteMatch("*/*/recurring/:recurringID");

  if (showEditRecurringModal) {
    return <EditRecurringGiftModal onModalClose={onModalClose} />;
  }

  return null;
}
